import React from 'react'
import { RichText } from 'marketing-site/src/library/elements/RichText'
import { Statistic } from 'marketing-site/src/library/elements/Statistic'
import { EditorialListWithImage } from 'marketing-site/src/library/components/EditorialListWithImage'
import { SidebarTypes, ContentTypes } from './index'
import { EditorialInfo } from '../../elements/EditorialInfo'
import { TestimonialTextOnly } from 'marketing-site/src/library/components/TestimonialTextOnly'
import { TestimonialLink } from 'marketing-site/src/library/elements/TestimonialLink'
import { IDLink } from 'marketing-site/src/library/components/IDLink'
import EditorialImageOrVideo from './imageorvideo'

type IProps = SidebarTypes | ContentTypes

export default function EditorialWrapItem(props: IProps) {
  if (!props) return null

  switch (props.type) {
    case 'Richtext': {
      return <RichText {...props} />
    }
    case 'editorialInfo': {
      return <EditorialInfo {...props} />
    }
    case 'statistic': {
      return <Statistic {...props} />
    }
    case 'idLink': {
      return <IDLink {...props} />
    }
    case 'editorialListWithImage': {
      return <EditorialListWithImage {...props} />
    }
    case 'ImageOrVideo': {
      return <EditorialImageOrVideo {...props} />
    }
    case 'TestimonialTextOnly': {
      return (
        <div className="editorial-wrap__testimonial">
          <TestimonialTextOnly {...props} />
        </div>
      )
    }
    case 'TestimonialLink': {
      return <TestimonialLink {...props} />
    }
    default: {
      return null
    }
  }
}
